import { CSSProperties, useEffect, useRef } from 'react';
import { Control, Controller, FieldError, FieldValues } from 'react-hook-form';

import { FormError } from 'coreOld/elements';
import { AlignText, Size } from 'coreOld/enums';

import { Input } from './textInputStyle';

interface IProps {
  control: Control<FieldValues, object>;
  name?: string;
  defaultValue?: string;
  placeholder?: string;
  label?: string;
  hasIcon?: boolean;
  style?: CSSProperties;
  size?: Size;
  type?: string;
  disabled?: boolean;
  isDisabledState?: boolean;
  isEditable?: boolean;
  fontInherit?: boolean;
  hasBorder?: boolean;
  textAlign?: AlignText;
  onChange?;
  onBlur?;
  onKeyDown?;
  error?: FieldError | string;
  showFieldError?: boolean;
  autoFocus?: boolean;
}

const TextInputWithController = ({
  name,
  control,
  defaultValue = '',
  placeholder = '',
  label,
  hasIcon,
  style,
  size,
  type,
  disabled,
  isDisabledState,
  isEditable = true,
  fontInherit,
  hasBorder,
  onChange,
  onBlur,
  onKeyDown,
  textAlign,
  error,
  showFieldError = false,
  autoFocus = false,
}: IProps) => {
  const ref = useRef(null);

  useEffect(() => {
    if (autoFocus) {
      ref?.current.focus();
    }
  }, [autoFocus, disabled, isDisabledState, isEditable]);

  return (
    <>
      <Controller
        name={name}
        control={control}
        render={({ field }) => (
          <Input
            {...{
              ...field,
              onChange: (event) => {
                if (onChange) {
                  onChange(event);
                }

                if (event.target?.value) {
                  ref?.current.focus();
                }

                field.onChange(event.target?.value || '');
              },
              id: field.name,
              type,
              value: isDisabledState && !field.value ? '-' : field.value || defaultValue,
              defaultValue,
              placeholder,
              hasIcon,
              style,
              size,
              disabled,
              isDisabledState,
              isEditable,
              fontInherit,
              hasBorder,
              textAlign,
              onBlur: onBlur || field.onBlur,
              onKeyDown,
              error,
              autoFocus,
              tabIndex: disabled ? -1 : 0,
              label,
              ref,
            }}
          />
        )}
      />
      {error && showFieldError && <FormError error={error} />}
    </>
  );
};

export default TextInputWithController;
